import { useState } from 'react';
import { Button, Card, Form, Input, Modal, Select, Space, Tag, Typography, message } from 'antd';
import { useReportDefinitions } from '@/entities/report/api/hooks';
import type { ReportDefinition } from '@/entities/report/model/reportSchema';
import { badgeColors, SCHEDULE_OPTIONS, reportTagBadgeVariant } from '../constants';
import { generateReportCsv, generateReportPdf } from '../utils';
import s from './ReportList.module.scss';

const { Text } = Typography;

export function ReportList() {
  const { data: reports } = useReportDefinitions();

  const [reportModal, setReportModal] = useState<ReportDefinition | null>(null);
  const [reportPeriod, setReportPeriod] = useState('');
  const [reportDept, setReportDept] = useState('');
  const [schedules, setSchedules] = useState<Record<number, string>>({});

  return (
    <>
      <Card size="small" title={<span className={s['root__card-title']}>Готовые отчёты</span>}>
        {reports?.map((r: ReportDefinition) => (
          <div key={r.id} className={s['root__report-row']}>
            <div className={s['root__report-info']}>
              <Text strong className={s['root__report-title']}>
                {r.title}
              </Text>
              <div className={s['root__report-meta']}>
                <Tag color={badgeColors[reportTagBadgeVariant(r.id)] ?? 'default'} className={s['root__module-tag']}>
                  {r.module}
                </Tag>
                {schedules[r.id] && (
                  <Tag color="blue" className={s['root__module-tag']}>
                    {SCHEDULE_OPTIONS.find((o) => o.value === schedules[r.id])?.label}
                  </Tag>
                )}
              </div>
            </div>
            <Space wrap>
              <Button size="small" onClick={() => generateReportPdf(r)}>
                PDF
              </Button>
              <Button size="small" onClick={() => generateReportCsv(r)}>
                Р7
              </Button>
              <Button
                size="small"
                type="dashed"
                onClick={() => {
                  setReportModal(r);
                  setReportPeriod('');
                  setReportDept('');
                }}
              >
                Фильтры
              </Button>
              <Select
                size="small"
                className={s['root__schedule-select']}
                value={schedules[r.id] ?? ''}
                onChange={(v) => {
                  setSchedules((prev) => ({ ...prev, [r.id]: v }));
                  message.success(
                    v
                      ? `Расписание «${SCHEDULE_OPTIONS.find((o) => o.value === v)?.label}» установлено`
                      : 'Расписание снято',
                  );
                }}
                options={SCHEDULE_OPTIONS}
                placeholder="Расписание"
              />
            </Space>
          </div>
        ))}
      </Card>

      <Modal
        title={reportModal ? `Формирование отчёта: ${reportModal.title}` : ''}
        open={!!reportModal}
        onCancel={() => setReportModal(null)}
        footer={
          <Space>
            <Button onClick={() => setReportModal(null)}>Отмена</Button>
            <Button
              onClick={() => {
                if (reportModal) generateReportCsv(reportModal, reportPeriod, reportDept);
                setReportModal(null);
              }}
            >
              Р7
            </Button>
            <Button
              type="primary"
              onClick={() => {
                if (reportModal) generateReportPdf(reportModal, reportPeriod, reportDept);
                setReportModal(null);
              }}
            >
              PDF
            </Button>
          </Space>
        }
        destroyOnHidden
      >
        <Form layout="vertical">
          <Form.Item label="Период">
            <Input
              value={reportPeriod}
              onChange={(e) => setReportPeriod(e.target.value)}
              placeholder="Напр. 01.01.2026 – 30.06.2026"
            />
          </Form.Item>
          <Form.Item label="Подразделение">
            <Select
              value={reportDept}
              onChange={setReportDept}
              options={[
                { value: '', label: 'Все подразделения' },
                { value: 'Цех №1', label: 'Цех №1' },
                { value: 'Цех №2', label: 'Цех №2' },
                { value: 'Цех №3', label: 'Цех №3' },
                { value: 'ОТК', label: 'ОТК' },
                { value: 'ОГТ', label: 'ОГТ' },
              ]}
            />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
}
